module.exports = __webpack_public_path__ + "static/media/step2.c7d4b9ea.png";